import STATE from "Constants/campaign/civicactioncenter/state";
import { loadLanguageAsync } from "JS/i18n";

const mod = {
  namespaced: true,
  state: {
    [STATE.SELECTED_LANGUAGE]: "",
    [STATE.VOTER_INFORMATION]: {
      stateRegistrationInfo: {
        raceList: [],
        partyList: [],
        requiresRace: false,
        requiresParty: false,
        requiresRaceMessage: null,
        requiresPartyMessage: null,
        paperRegistration: {
          availableLanguages: []
        }
      }
    },
    [STATE.VALIDATION_ERROR_MSG]: "",
    [STATE.IS_MOBILE]: false,
    [STATE.ADVOCATE_COOKIE_INFO]: {},
    [STATE.REGISTRATION_COMPLETED]: false
  },
  mutations: {
    [STATE.SELECTED_LANGUAGE](state, language) {
      state[STATE.SELECTED_LANGUAGE] = language;
    },
    [STATE.VOTER_INFORMATION](state, voterInformation) {
      state[STATE.VOTER_INFORMATION] = voterInformation;
    },
    [STATE.VALIDATION_ERROR_MSG](state, validationErrorMsg) {
      state[STATE.VALIDATION_ERROR_MSG] = validationErrorMsg;
    },
    [STATE.IS_MOBILE](state, isMobile) {
      state[STATE.IS_MOBILE] = isMobile;
    },
    [STATE.ADVOCATE_COOKIE_INFO](state, advocateObj) {
      state[STATE.ADVOCATE_COOKIE_INFO] = advocateObj;
    },
    [STATE.REGISTRATION_COMPLETED](state, value) {
      state[STATE.REGISTRATION_COMPLETED] = value;
    }
  },
  actions: {
    [STATE.SELECTED_LANGUAGE]({ commit }, language) {
      commit(STATE.SELECTED_LANGUAGE, language);
      try {
        window.localStorage.setItem(STATE.SELECTED_LANGUAGE, language);
      } catch(e) {
        // If accessing localStorage fails, private browsing is enabled
      }
      loadLanguageAsync(language);
    },
    [STATE.VOTER_INFORMATION]({ commit }, voterInformation) {
      commit(STATE.VOTER_INFORMATION, voterInformation);
    },
    [STATE.VALIDATION_ERROR_MSG]({ commit }, validationErrorMsg) {
      commit(STATE.VALIDATION_ERROR_MSG, validationErrorMsg);
    },
    [STATE.IS_MOBILE]({ commit }, isMobile) {
      commit(STATE.IS_MOBILE, isMobile);
    },
    [STATE.ADVOCATE_COOKIE_INFO]({ commit }, advocateObj) {
      commit(STATE.ADVOCATE_COOKIE_INFO, advocateObj);
    },
    [STATE.REGISTRATION_COMPLETED]({ commit }, value) {
      commit(STATE.REGISTRATION_COMPLETED, value);
    }
  },
  getters: {
    [STATE.SELECTED_LANGUAGE]: state => state[STATE.SELECTED_LANGUAGE] || "",
    [STATE.HAS_ADVOCATE]: (state, getters, rootState) => {
      try {
        const advocate = rootState[STATE.SCOPE_FORMS][STATE.ADVOCATE_RECORD];
        return !!advocate.id;
      } catch (e) {
        return false;
      }
    },
    [STATE.VALIDATION_ERROR_MSG]: state =>
      state[STATE.VALIDATION_ERROR_MSG] || "",
    [STATE.ADVOCATE_COOKIE_INFO]: state =>
      state[STATE.ADVOCATE_COOKIE_INFO] || {},
    [STATE.CALENDAR_DATES]: state =>
      state[STATE.VOTER_INFORMATION][STATE.CALENDAR_DATES] || false
  }
};

export default mod;
